
    import {
      getAllGrades,
      createGrade,
      createAllGrades,
      updateGrade,
      deleteGrade
    } from "@/services/grade";

    const state = {
      grades: [],
      processed: false
    };

    const getters = {
      getGrades(state) {
        return state.grades;
      },
      gradeProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchGrades({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllGrades(
              params
            )
              .then(response => {
                commit("SET_GRADES", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createGrade({ commit }, grade) {
          return new Promise((resolve, reject) => {
            createGrade(grade)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllGrades({ commit }, grades) {
          return new Promise((resolve, reject) => {
            createAllGrades(grades)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateGrade({ commit }, grade) {
          return new Promise((resolve, reject) => {
            updateGrade(grade)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteGrade({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteGrade(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_GRADES(state, data) {
        state.grades = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    